import {combineReducers} from "redux";
import {routerReducer as routing} from "react-router-redux";

// import authentication from "./authentication";
import {algorithmCategory} from "scenes/Algorithm/AlgorithmCategory/algorithmCategory";
import {algorithmList} from "scenes/Algorithm/AlgorithmList/algorithmList";
import {algorithmAdd} from "scenes/Algorithm/AlgorithmAdd/algorithmAdd";
import {algorithmEdit} from "scenes/Algorithm/AlgorithmEdit/algorithmEdit";
import {algorithmView} from "scenes/Algorithm/AlgorithmView/algorithmView";
import {algorithmLibrary} from "scenes/Algorithm/AlgorithmLibrary/algorithmLibrary";
import {algorithmManagement} from "scenes/Algorithm/AlgorithmManagement/algorithmManagement";
import {applicationMarketPortal} from "scenes/Application/ApplicationMarketPortal/applicationMarketPortal";
import {applicationMarketList} from "scenes/Application/ApplicationMarketList/applicationMarketList";
import {applicationMarketView} from "scenes/Application/ApplicationMarketView/applicationMarketView";
import {applicationMarketManagement} from "scenes/Application/ApplicationMarketManagement/applicationMarketManagement";
import {deployMarketApp} from "scenes/Application/DeployMarketApp/deployMarketApp";
import {applicationCategory} from "scenes/Application/ApplicationCategory/applicationCategory";

import {applicationVerify} from "scenes/Application/ApplicationVerify/applicationVerify";
import {applicationVerifyPlatform} from "scenes/Application/ApplicationVerifyPlatform/applicationVerifyPlatform";
import {applicationManagementEnterprise} from "scenes/Application/ApplicationManagementEnterprise/applicationManagementEnterprise";
import {applicationManagementPrivate} from "scenes/Application/ApplicationManagementPrivate/applicationManagementPrivate";
import {applicationManagementPlatform} from "scenes/Application/ApplicationManagementPlatform/applicationManagementPlatform";
import {applicationList} from "scenes/Application/ApplicationList/applicationList";
import {applicationAdd} from "scenes/Application/ApplicationAdd/applicationAdd";
import {applicationEdit} from "scenes/Application/ApplicationEdit/applicationEdit";
import {moduleAdd} from "scenes/Application/ApplicationEdit/ModuleAdd/moduleAdd";
import {moduleEdit} from "scenes/Application/ApplicationEdit/ModuleEdit/moduleEdit";
import {versionAdd} from "scenes/Application/VersionAdd/versionAdd";
import {versionEdit} from "scenes/Application/VersionEdit/versionEdit";
import {resourceAdd} from "scenes/Application/ResourceAdd/resourceAdd";
// import {resourceEdit} from "scenes/Application/ResourceEdit/resourceEdit";

import {createEnterpriseDetails} from "scenes/UserService/Enterprise/createEnterpriseDetails";
import consoleReducer from "scenes/common/Console/data/consoleRedux";
import {createUserCertify} from "scenes/UserService/User/createUserCertify";
import {enterpriseList} from "scenes/UserService/EnterprisesPage/enterpriseList";
import {editEnterpriseDetails} from "scenes/UserService/Enterprise/editEnterpriseDetails";
import {editUserInfoBase} from "scenes/UserService/User/editUserCertify";
import {editUserDetails} from "scenes/UserService/User/editUserDetails";
import {initializeTenantSpace} from "scenes/Space/InitializeTenantSpace/initializeTenantSpace";
import {increaseQuota} from "scenes/Space/IncreaseQuota/increaseQuota";
import {showDatabaseService} from "../scenes/Space/DatabaseService/showDatabaseService"
import {namespaceVerify} from "../scenes/Space/NamespaceVerify/namespaceVerify"
import locale from "./locale";
import {messageCenterReducer} from "scenes/UserService/Message/MessgeCenter";
import PortalReducer from "scenes/common/Portal/data/PortalReducer";
import simple from "./simple";
import SpaceAppManagementPageReducer from "scenes/SpaceAppsManagement/data/SpaceAppsManagementReducer";
import {roleListReducer} from "scenes/UserService/RoleList/RoleList";
import {registerReducer} from "scenes/UserService/Register/Register";
import userDataReducer from "./userData";
import {editUserJobInformation} from "scenes/UserService/EditUserJob/editUserJobInformation";
import {userDetails} from "scenes/UserService/User/userDetails";
import {userList} from "scenes/UserService/UsersPage/userList";
import {verifyEnterpriseAuth} from "scenes/UserService/VerifyEnterpriseAuth/verifyEnterpriseAuth";
import {verifyAlgorithm} from "scenes/Algorithm/VerifyAlgorithm/verifyAlgorithm";
import {websocket} from "./websocket";
import {personInfo} from "../scenes/common/ConsoleHome/components/PersonInfo/PersonInfo";
import {portalKey} from "../scenes/common/Portal/data/portalKey";
import AppConfigAndConditionReducer from "../scenes/AppConfigAndConditionPage/data/AppConfigAndConditionReducer";
import consoleApplicationReducer from "../scenes/ConsoleApplicationPage/consoleApplicationRedux";
import {projectPanel} from "../scenes/Algorithm/Project/ProjectWorkbench/ProjectPanel";
import {projectList} from "../scenes/Algorithm/Project/ProjectTable/projectTableData";

import {menuManagement} from "scenes/Menu/MenuManagement/menuManagement";
import {roleConfigManagement} from "scenes/Menu/RoleConfigManagement/roleConfigManagement";

import {equipmentCertifyList} from "scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyList/equipmentCertifyList";
import {equipmentCertifyRegister} from "scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyRegister/equipmentCertifyRegister";
import {equipmentCertifyDestroy} from "scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyDestroy/equipmentCertifyDestroy";
import {equipmentCertifyVerify} from "scenes/Equipment/EquipmentCertifyManagement/EquipmentCertifyVerify/equipmentCertifyVerify";
import {equipmentTypeList} from "scenes/Equipment/EquipmentType/EquipmentTypeList/equipmentTypeList";
import {equipmentTypeAdd} from "scenes/Equipment/EquipmentType/EquipmentTypeAdd/equipmentTypeAdd";
import {equipmentTypeEdit} from "scenes/Equipment/EquipmentType/EquipmentTypeEdit/equipmentTypeEdit";
import {equipmentList} from "scenes/Equipment/EquipmentManagement/EquipmentList/equipmentList";
import {equipmentAdd} from "scenes/Equipment/EquipmentManagement/EquipmentAdd/equipmentAdd";
import {equipmentEdit} from "scenes/Equipment/EquipmentManagement/EquipmentEdit/equipmentEdit";
import {equipmentDetail} from "scenes/Equipment/EquipmentManagement/EquipmentDetail/equipmentDetail";
import {equipmentConfig} from "scenes/Equipment/EquipmentManagement/EquipmentConfig/equipmentConfig";
import {equipmentDataView} from "scenes/Equipment/EquipmentManagement/EquipmentDataView/equipmentDataView";
import {equipmentLog} from "scenes/Equipment/EquipmentManagement/EquipmentLog/equipmentLog";
import {equipmentBackupList} from "scenes/Equipment/EquipmentBackup/EquipmentBackupList/equipmentBackupList";
import {equipmentBackupConfig} from "scenes/Equipment/EquipmentBackup/EquipmentBackupConfig/equipmentBackupConfig";
import {equipmentBackupDetail} from "scenes/Equipment/EquipmentBackup/EquipmentBackupDetail/equipmentBackupDetail";
import accountManagement from "../scenes/Account/AccountManagement/accountManagement";

// import {editUserJobInformation}  from "scenes/EditUserJobInformation/editUserJobInformation"
import {applyTsdatabaseSpace} from "../scenes/Space/ApplyTsdatabaseSpace/applyTsdatabaseSpace"
import {applyBigdataQuota} from "../scenes/Space/ApplyBigdataQuota/applyBigdataQuota"
import {employeeList} from "scenes/UserService/EmployeeList/employeeList";
import {receiveMessage} from "../scenes/Message/ReceiveMessage/receiveMessage";
// import {messageSent} from "../scenes/Message/MessageSent/messageSent";
import {verifyUserDetail} from "scenes/UserService/VerifyUserDetail/verifyUserDetail";
import {messageCategory} from "scenes/MessageManagement/MessageCategory/messageCategory";
import {messageType} from "scenes/MessageManagement/MessageType/messageType";
import {messageGroup} from "scenes/MessageManagement/MessageGroup/messageGroup";
import {messageSent} from "scenes/MessageManagement/MessageSent/messageSent";
import {messageCenter} from "scenes/MessageManagement/MessageCenter/messageCenter";
import reducer from "reducers/authenticationNew";
import DeploymentAppsManagementReducer from "scenes/DeploymentAppsManagement/data/DeploymentAppsManagementReducer";

export default combineReducers({
  simple,
  authentication: reducer,
  locale,
  routing,
  portal: PortalReducer,
  console: consoleReducer,
  spaceAppsManagement: SpaceAppManagementPageReducer,
  deploymentAppsManagement: DeploymentAppsManagementReducer,
  appConfigAndConditionPage: AppConfigAndConditionReducer,
  registerReducer,
  enterpriseList,
  userData: userDataReducer,
  userList,
  employeeList,
  editUserJobInformation,
  userDetails,
  editUserDetails,
  editEnterpriseDetails,
  roleListReducer,
  editUserInfoBase,
  messageCenterReducer,
  createEnterpriseDetails,
  verifyEnterpriseAuth,
  createUserCertify,
  initializeTenantSpace,
  increaseQuota,
  showDatabaseService,
  applyTsdatabaseSpace,
  namespaceVerify,
  applyBigdataQuota,
  websocket,
  personInfo,
  consoleApplication: consoleApplicationReducer,

  algorithmCategory,
  algorithmList,
  algorithmAdd,
  algorithmEdit,
  algorithmView,
  algorithmLibrary,
  algorithmManagement,
  verifyAlgorithm,

  applicationMarketPortal,
  applicationMarketList,
  applicationMarketView,
  applicationMarketManagement,
  deployMarketApp,

  applicationCategory,

  applicationVerify,
  applicationVerifyPlatform,
  applicationManagementEnterprise,
  applicationManagementPrivate,
  applicationManagementPlatform,
  applicationList,
  applicationAdd,
  applicationEdit,
  moduleAdd,
  moduleEdit,
  versionAdd,
  versionEdit,
  resourceAdd,
  // resourceEdit,

  menuManagement,
  roleConfigManagement,

  equipmentCertifyList,
  equipmentCertifyRegister,
  equipmentCertifyDestroy,
  equipmentCertifyVerify,
  equipmentTypeList,
  equipmentTypeAdd,
  equipmentTypeEdit,
  equipmentList,
  equipmentAdd,
  equipmentEdit,
  equipmentDetail,
  equipmentConfig,
  equipmentDataView,
  equipmentLog,
  equipmentBackupList,
  equipmentBackupConfig,
  equipmentBackupDetail,
  accountManagement,
  //editUserJobInformation,
  messageCategory,
  messageType,
  messageGroup,
  messageSent,
  messageCenter,
  projectPanel,
  projectList,
  receiveMessage,
  // messageSent,
  verifyUserDetail,
  portalKey
});
